import { type RefObject, createContext } from 'react';

type TargetRef = RefObject<HTMLDivElement | null>;

export type RegisteredTarget = {
  ref: TargetRef;
  title: string;
};

type NavigationTabsContextValue = {
  register: (tab: RegisteredTarget) => void;
  unregister: (title: string) => void;
};

export const NavigationTabsContext =
  createContext<NavigationTabsContextValue | null>(null);
